var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemphisStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 532,
    viewBox: "0 0 533 532",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.485 43.9759L373.924 14.1196",
    stroke: "black",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.493 6.86402L366.916 51.2345",
    stroke: "black",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7788 507.425L117.218 477.569",
    stroke: "black",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.787 470.313L110.21 514.684",
    stroke: "black",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.499 525V292.5C194.098 292.5 160.499 342.167 152.499 367C133.699 492.6 219.332 524.667 264.499 525Z",
    stroke: "black",
    strokeWidth: 13
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266 347L510.5 252L250 34.5L224 84L146 103.5L124.5 34.5L72 48",
    stroke: "black",
    strokeWidth: 13
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 52L13.5 61.5L22 95L94 75C100.5 97.8333 113.7 144.6 114.5 149C115.3 153.4 166.833 138.833 192.5 131L215.5 212L253.5 202.5L219.5 86.5",
    stroke: "black",
    strokeWidth: 13
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.5 132.5L15 441L146 395.5",
    stroke: "black",
    strokeWidth: 13
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 479.178,
    y: 130.157,
    width: 48.4519,
    height: 48.4519,
    rx: 24.2259,
    transform: "rotate(5.44348 479.178 130.157)",
    stroke: "black",
    strokeWidth: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.502,
    y: 228.907,
    width: 48.4519,
    height: 48.4519,
    rx: 24.2259,
    transform: "rotate(5.44348 17.502 228.907)",
    stroke: "black",
    strokeWidth: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemphisStyle);
export default __webpack_public_path__ + "static/media/memphis-style.8f85d8811fc14eee378a25a71221ff97.svg";
export { ForwardRef as ReactComponent };